import { ResponseProductAttribute } from '@/data/types/Product';

export const validateStoreExclude = (attribute: ResponseProductAttribute, valueExclude: string) => {
	if (attribute?.values) {
		const values = attribute?.values[0];
		if (values && values?.value) {
			const isExclude = Array.isArray(values?.value)
				? values?.value?.includes(valueExclude)
				: values?.value === valueExclude;
			if (!isExclude) {
				return false;
			}
		}
	}
	return true;
};
